import React, { useEffect, useState } from 'react';
import RollSvg from '../../../assets/roll.svg';
import CakeSvg from '../../../assets/cake.svg';
import SausageSvg from '../../../assets/sausage.svg';
import { fruitsResumeData } from '../constants';
import { FruitType, useAppContext } from '../../../context';

interface ICandidateIcon {
	type: FruitType;
	isVoted: boolean;
	isAccepted: boolean;
}

export const CandidateIcon: React.FC<ICandidateIcon> = ({ type, isVoted, isAccepted }) => {
	const [svgContent, setSvgContent] = useState<string>('');
	const [wasVoted, setWasVoted] = useState(isVoted);

	useEffect(() => {
		if (isVoted) {
			setWasVoted(true);
		}
	}, [isVoted]);

	const iconSrc = {
		roll: RollSvg,
		cake: CakeSvg,
		sausage: SausageSvg
	}[type];

	useEffect(() => {
		fetch(iconSrc)
			.then(res => res.text())
			.then(text => {
				const color = wasVoted
					? (isAccepted ? '#C6E7C5' : '#FB9BB4')
					: '#EFEFEF';
				const newSvg = text.replace(/<path/g, `<path fill="${color}"`);
				setSvgContent(newSvg);
			});
	}, [wasVoted, isAccepted, iconSrc]);

	return (
		<div
			className="w-[57px] h-[64px]"
			dangerouslySetInnerHTML={{ __html: svgContent }}
		/>
	);
}
interface ICandidatesList {
	stage: number;
	isResult: boolean;
}

export const CandidatesList: React.FC<ICandidatesList> = ({ stage, isResult }) => {
	const { fruitType } = useAppContext();
	const { forms } = fruitsResumeData[fruitType]
	return (
		<div className="flex mt-4 gap-4 justify-between w-full">
			{Array.from({ length: 5 }, (_, index) => (
				<CandidateIcon
					key={index}
					type={fruitType}
					isVoted={index < stage - 1 || isResult && index <= stage - 1}
					isAccepted={index < stage ? forms[index].isAcceptCorret : false}
				/>
			))}
		</div>
	);
};
